import { PlusIcon, TrashIcon, XMarkIcon } from "@heroicons/react/16/solid"

export type CourseSection = { title: string; items: string[] }

type Props = {
  sections: CourseSection[]
  setSections: (s: CourseSection[]) => void
}

export const SectionsEditor = ({ sections, setSections }: Props) => {
  const addSection = () => setSections([...sections, { title: "", items: [] }])

  const updateSection = (i: number, section: CourseSection) => {
    const copy = [...sections]
    copy[i] = section
    setSections(copy)
  }

  const removeSection = (i: number) => setSections(sections.filter((_, idx) => idx !== i))

  if (sections.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-sm text-gray-400 mb-3">Разделов пока нет</p>
        <button
          onClick={addSection}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors"
        >
          <PlusIcon className="w-4 h-4" />
          Добавить первый раздел
        </button>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {sections.map((s, i) => (
        <div key={i} className="border border-gray-100 rounded-xl p-4 space-y-3 bg-gray-50/40">
          {/* Section header */}
          <div className="flex items-center gap-2">
            <span className="w-6 h-6 rounded-md bg-blue-50 text-blue-600 text-xs font-bold flex items-center justify-center flex-shrink-0">
              {i + 1}
            </span>
            <input
              value={s.title}
              onChange={(e) => updateSection(i, { ...s, title: e.target.value })}
              placeholder="Название раздела"
              className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition bg-white"
            />
            <button
              onClick={() => removeSection(i)}
              className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
            >
              <TrashIcon className="w-3.5 h-3.5" />
            </button>
          </div>

          {/* Items */}
          <div className="space-y-2 pl-8">
            {s.items.map((item, j) => (
              <div key={j} className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-gray-300 flex-shrink-0" />
                <input
                  value={item}
                  onChange={(e) => {
                    const items = [...s.items]
                    items[j] = e.target.value
                    updateSection(i, { ...s, items })
                  }}
                  placeholder={`Пункт ${j + 1}`}
                  className="flex-1 border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition bg-white"
                />
                <button
                  onClick={() => updateSection(i, { ...s, items: s.items.filter((_, k) => k !== j) })}
                  className="p-1 text-gray-300 hover:text-red-400 transition-colors"
                >
                  <XMarkIcon className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}

            <button
              onClick={() => updateSection(i, { ...s, items: [...s.items, ""] })}
              className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-blue-500 transition-colors mt-1"
            >
              <PlusIcon className="w-3.5 h-3.5" />
              Добавить пункт
            </button>
          </div>
        </div>
      ))}

      <button
        onClick={addSection}
        className="w-full border-2 border-dashed border-gray-200 rounded-xl py-3 text-sm font-medium text-gray-400 hover:border-blue-400 hover:text-blue-500 transition-colors flex items-center justify-center gap-2"
      >
        <PlusIcon className="w-4 h-4" />
        Добавить раздел
      </button>
    </div>
  )
}
